import React from 'react';
import { ThumbsUp, MessageSquare, Share2, Globe, MoreHorizontal } from 'lucide-react';
import { MediaDisplay } from './MediaDisplay';
import type { PreviewProps } from './types';

export const GoogleBusinessPreview: React.FC<PreviewProps> = ({ content, brand, mediaUrl }) => {
  return (
    <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden">
      {/* Header */}
      <div className="p-4">
        <div className="flex items-start gap-3">
          <div className="h-12 w-12 rounded-lg bg-gray-100 overflow-hidden">
            {brand?.logo ? (
              <img src={brand.logo} alt="" className="w-full h-full object-cover" />
            ) : (
              <div className="w-full h-full bg-gray-200" />
            )}
          </div>
          <div>
            <h3 className="font-medium text-blue-600">{brand?.name || 'Company Name'}</h3>
            <p className="text-xs text-gray-500">
              2h • Public
            </p>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="px-4 pb-3">
        <p className="text-gray-900 whitespace-pre-line" style={{ fontSize: '0.8rem' }}>{content}</p>
      </div>

      {/* Media */}
      {mediaUrl && (
        <div className="aspect-video bg-gray-100">
          <MediaDisplay
            mediaUrl={mediaUrl}
            altText="Google Business media"
            type="image"
            aspectRatio="16/9"
          />
        </div>
      )}

      {/* Actions */}
      <div className="px-4 py-3 flex items-center gap-6 text-gray-600">
        <button className="flex items-center gap-2">
          <ThumbsUp className="w-5 h-5" />
          <span className="text-sm">Like</span>
        </button>
        <button className="flex items-center gap-2">
          <MessageSquare className="w-5 h-5" />
          <span className="text-sm">Comment</span>
        </button>
        <button className="flex items-center gap-2">
          <Share2 className="w-5 h-5" />
          <span className="text-sm">Share</span>
        </button>
      </div>
    </div>
  );
};